import React, { useState } from 'react';
import styles from './formFaqAccordion.module.scss';
import arrowRight from '../../../../src/assets/images/Right-arrow.svg';
import CloseIcon from '@material-ui/icons/Close';
import externalLink from '../../../../src/assets/images/external-link.svg';

const FormFaqAccordion = props => {
  const [isOpen, setOpen] = useState(false);
  return (
    <div className={styles.faqForm}>
      <div
        className={`${styles.title} ${isOpen ? styles.expanded : styles.collapsed}`}
        onClick={() => setOpen(!isOpen)}
      >
        {!isOpen ? (
          <span className={`${styles.chevron} ${styles.bottom}`}></span>
        ) : (
          <span className={`${styles.chevron} ${styles.top}`}></span>
        )}
        {props.title}
        <img src={arrowRight} alt={`drill down arrow`} className={`${styles.drillDownArrow}`} />
      </div>
      <div
        dangerouslySetInnerHTML={{ __html: props.text }}
        className={`${isOpen ? styles.open : styles.close} ${styles.expandedSection}`}
      />

      <div className={` ${isOpen ? styles.open : null}`}>
        <div className={`${styles.mobileSidePanel}`}>
          <div className={styles.mobiletitle}>
            <CloseIcon className={styles.menuIcon} onClick={() => setOpen(false)} />
          </div>
          <div className={styles.mobileContent}>
            <img src={`../images/${props.icon}`} alt="icon"></img>
            <h3> {props.title}</h3>
            <div dangerouslySetInnerHTML={{ __html: props.text }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormFaqAccordion;
